import { SMS_MODULE_URL } from '@shared/helpers/env';
import { ExtendApiService } from '@shared/services/ExtendApiService';

class SmsServiceClass extends ExtendApiService {
  constructor(opts) {
    super(opts);
  }

  downloadReport(format, data) {
    return this.http.post(`detailed/export/${format}`, data);
  }

  // downloadFile(file_id) {
  //   return this.http.request({
  //     method: 'GET',
  //     url: `/export/files/${file_id}/download`
  //   });
  // }

  // getStatusFile(data) {
  //   return this.http.get(`/export/files/${data.file_id}`, data);
  // }
}


// export const SmsService = new SmsServiceClass({
//   api_version: 2,
//   resource: 'mailing'
// });


export const SmsService = new SmsServiceClass({
  api_version: 1,
  resource: 'stats/messages',
  base_url: SMS_MODULE_URL
});
